import { connect } from 'react-redux';
import { getSetupStateRequest } from '../actions/wizardActions';
import Retry from '../../shared/components/Retry/Retry';

const mapDispatchToProps = { retry: getSetupStateRequest };

export default connect(null, mapDispatchToProps)(Retry);
